// @flow strict

import * as React from 'react'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import styles from './ModalWrapper.module.scss'
// TODO - Swap out for correct close button asset once we have it
import closeX from '../../static/images/icons/icon-close.svg'
import {
  type PropsWithChildren,
  Button,
  AccessibilityText,
} from '@mondough/public-web-components'

type ModalProps = {
  isOpen: boolean | (() => boolean),
  onDismiss: () => void,
  ariaLabelledby: string,
  buttonStyles?: string,
}

// TODO - Make better for short screens at some later time in the future not during a big product launch
const ModalWrapper = (props: PropsWithChildren<ModalProps>) => (
  <DialogOverlay isOpen={props.isOpen} onDismiss={props.onDismiss}>
    <DialogContent aria-labelledby={props.ariaLabelledby}>
      <div className={styles.modalWrapper}>{props.children}</div>
      <div className={styles.closeButton}>
        <Button
          className={props.buttonStyles || styles.paidButtonStylesClose}
          onClick={props.onDismiss}
        >
          <AccessibilityText>Close</AccessibilityText>
          <img src={closeX} alt="" />
        </Button>
      </div>
    </DialogContent>
  </DialogOverlay>
)

export default ModalWrapper
